import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import CustomSidePanel from "../../../../../components/blank-side-pannel/custom-side-pannel";
import { BlueGradientButton } from "../../../../../components/button";
import { DropdownWithApiSearch } from "../../../../../components/dropdowns/DropdownWithApiSearch";
import * as accountCampaignPricingSmsActions from "../../../store/actions/account_campaign_pricing_sms_actions";
import RegulationsDropdown from "../../../../../components/specific/dropdowns/RegulationsDropdown";

export default function AccountCampaignPricingSmsSidePanel({ show, pricingData, handleClose }) {
  const [formData, setFormData] = useState({});
  const dispatch = useDispatch();
  const params = useParams();

  useEffect(() => {
    const { gateway, regulation, price, additionalPrice } = pricingData || {};
    const tempFormData = {
      gateway,
      regulation,
      price,
      additionalPrice,
      finalPrice: ((price || 0) + (additionalPrice || 0)).toFixed(4),
    };
    setFormData(tempFormData);
  }, [pricingData]);

  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = {
      id: params.accountId,
      loadingData: { id: params.accountId },
      data: {
        accountId: params.accountId,
        _id: pricingData._id,
        gateway: formData.gateway,
        regulation: formData.regulation,
        // price: formData.price,
        additionalPrice: formData.additionalPrice,
      },
    };
    dispatch(accountCampaignPricingSmsActions.editPricingOfAccountSmsCampaignRequest(payload));
    handleClose();
  };

  const handleChange = (inputKey, inputValue) => {
    if (inputKey === "additionalPrice") {
      const _inputValue = typeof inputValue === "number" ? inputValue : Number(inputValue);

      setFormData((prev) => {
        return {
          ...prev,
          [inputKey]: _inputValue,
          finalPrice: ((_inputValue || 0) + (prev.price || 0)).toFixed(4).replace(/\.?0+$/, ''),
        };
      });
    }
    else if (inputKey === "finalPrice") {
      const _inputValue = typeof inputValue === "number" ? inputValue : Number(inputValue);
      setFormData((prev) => {
        return {
          ...prev,
          [inputKey]: _inputValue,
          additionalPrice: ((_inputValue || 0) - (prev.price || 0)).toFixed(4).replace(/\.?0+$/, ''),
        };
      });
    }
    else {
      setFormData((prev) => {
        return {
          ...prev,
          [inputKey]: inputValue,
        };
      });
    }
  };

  return (
    <CustomSidePanel
      title={`Country Name: ${pricingData.countryName}`}
      show={show}
      moduleName="Campaign Pricing - SMS"
      handleClose={handleClose}
      customStyles={{
        width: "50vw",
        right: "51vw",
      }}
    >
      <div className="card-header d-flex flex-stack align-items-center">
        <h3 className="card-title fw-bolder text-dark">{`Country Name: ${pricingData.countryName}`}</h3>
      </div>
      <div style={{ height: "calc(100vh - 70px)", overflowY: "auto" }} className="p-8">
        <FormDisplay {...{ formData, handleChange, handleClose, handleSubmit }} />
      </div>
    </CustomSidePanel >
  );
}

const FormDisplay = ({ formData, handleChange, handleClose, handleSubmit }) => {
  return (
    <Form onSubmit={handleSubmit} noValidate>
      <Row>
        <Col className="form-group" xs={6}>
          <label className="form-label text-gray-700">Gateway</label>
          <DropdownWithApiSearch
            label={formData.gateway}
            apiObjFunc={(searchText) => {
              return {
                url: "/user-service/api/super-admin/campaign/sms/gateway-names/search",
                query: { searchText },
              };
            }}
            mapOptions={(searchResults) =>
              searchResults.map((v) => {
                return { label: v.gatewayName, value: v.gatewayName };
              })
            }
            handleSelect={(selected) => handleChange("gateway", selected.label)}
          />
        </Col>
        <Col className="form-group" xs={6}>
          <Form.Label>Regulations</Form.Label>
          <RegulationsDropdown values={formData.regulation || []} handleChange={(values) => handleChange("regulation", values)} />

          {/* <Select
            placeholder="Regulations"
            value={regulationDropdownSelectedValues}
            options={regulationDropdownOptions}
            onChange={(values) => {
              const tempValue = values.map((v) => v.value);
              handleChange("regulation", tempValue);
            }}
            isMulti
          /> */}
          {/* <MultiSelectCheckboxDropdown
            options={regulationDropdownOptions}
            selectedValue={regulationDropdownSelectedValues}
            setSelectedValue={(value) => {
              const tempValue = value.map((v) => v.value);
              handleChange("regulation", tempValue);
            }}
          /> */}
        </Col>
      </Row>
      <Row>
        {/* <Col className="form-group" xs={6}>
          <label className="form-label text-gray-700">Price</label>
          <Form.Control type="number"  value={formData.price ?? 0} onChange={(e) => handleChange("price", e.target.value)} />
        </Col> */}
        {/* <Col className="form-group" xs={6}>
          <label className="form-label text-gray-700">Additional Price</label>
          <Form.Control type="number" value={formData.additionalPrice ?? 0} onChange={(e) => handleChange("additionalPrice", e.target.value)} />
        </Col> */}
        <Col className="form-group" xs={6}>
          <label className="form-label text-gray-700">Final Price</label>
          <Form.Control type="number" value={formData.finalPrice ?? 0} onChange={(e) => handleChange("finalPrice", e.target.value)} />
        </Col>
      </Row>

      <Form.Group className="d-flex gap-3 mt-10">
        <Button type="button" size="sm" variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <BlueGradientButton size="sm" type="submit">
          Save
        </BlueGradientButton>
      </Form.Group>
    </Form>
  );
};
